import { isModuleLoadError } from "~utils";

window.addEventListener("vite:preloadError", reload);

window.addEventListener(
  "unhandledrejection",
  (event: PromiseRejectionEvent): void => {
    if (!isModuleLoadError(event.reason)) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    reload();
  },
);

function reload(): void {
  if (reloading) return;
  reloading = true;
  window.location.reload();
}

let reloading = false;
